var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"date-range-filter-wrapper"},[_c('DateFilter',{on:{"input":_vm.handleRangeUpdate},model:{value:(_vm.selectedRange),callback:function ($$v) {_vm.selectedRange=$$v},expression:"selectedRange"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }